import React from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Jumbotron from 'react-bootstrap/Jumbotron';
import { LinkModel, ProductTileModel, TrustedHtmlString } from '../../models/globals';
import { ProductsCarousel } from '../category-products/ProductsCarousel';

interface HomeCareerNextStepCategoryProps {
    title: string;
    categoryLink: LinkModel;
    products: ProductTileModel[];
}

interface HomeCareerNextStepProps {
    header: string;
    descriptionHtml: TrustedHtmlString;
    categoryProducts: HomeCareerNextStepCategoryProps[];
}

const HomeCareerNextStep: React.FC<HomeCareerNextStepProps> = ({ header, descriptionHtml, categoryProducts }) => {
    return (
        <Jumbotron className="bg-white d-flex flex-column page-section mb-0 px-2 px-md-3">
            <Container className="clearfix page-section-inner" fluid>
                <h2 className="font-weight-light text-black mb-4">{header}</h2>
                <p
                    className="font-weight-light mb-4 page-section-content text-secondary"
                    dangerouslySetInnerHTML={{
                        __html: descriptionHtml,
                    }}
                ></p>
                {categoryProducts.map(({ title, categoryLink, products }) => {
                    if (!products.length) return null;

                    const testIdSuffix = `${title.replace(/\s/g, '-').toLowerCase()}-products-carousel`;
                    return (
                        <Col key={title} className="my-5">
                            <h3 className="text-uppercase text-black font-weight-bold small mb-4">{title}</h3>
                            <ProductsCarousel
                                products={products}
                                productsPerPage={1}
                                viewMode="mobile"
                                testIdSuffix={testIdSuffix}
                            />
                            <ProductsCarousel
                                products={products}
                                productsPerPage={2}
                                viewMode="tablet"
                                testIdSuffix={testIdSuffix}
                            />
                            <ProductsCarousel
                                products={products}
                                productsPerPage={3}
                                viewMode="desktop"
                                testIdSuffix={testIdSuffix}
                            />
                            <div className="text-center my-4">
                                <Button
                                    aria-label={`View All ${title}`}
                                    className="px-4 py-2 text-shadow-none"
                                    href={categoryLink.url}
                                    variant="primary"
                                >
                                    {categoryLink.name}
                                </Button>
                            </div>
                        </Col>
                    );
                })}
            </Container>
        </Jumbotron>
    );
};

export { HomeCareerNextStep, HomeCareerNextStepProps, HomeCareerNextStepCategoryProps };
